module.exports = __webpack_public_path__ + "img/lexile-table.600daeed.png";